export const getDefaultFieldDisplayType = (
  _field: string,
  hidden?: boolean,
): "hidden" | "block" => (hidden ? "hidden" : "block");
